import React, { useContext, useEffect, useState } from 'react';

import { HomeWrapper } from '../GamePage/GamePage.styled';
import Header from '../../components/Header/Header';
import QuickPlay from '../../components/Home/QuickPlay';
import UserInfo from '../../components/Home/UserInfo';
import GameTables from '../../components/GameTables';
import Leaderboard from '../../components/Leaderboard';
import Footer from '../../components/Footer';
import { PlayerContext } from '../../contexts/playerContext';
import { game } from '../../store/game';
import { useForm } from 'react-hook-form';
import { AddBalanceForm } from '../../components/ModalsManager/Modals/AddBalanceForm';
import { addNewGameTable } from '../../utils/addNewGameTable';
import { useNavigate } from 'react-router-dom';
import { socket } from '../../server/socket';
import { SocketEmit, SocketOn, TableData } from '../../types.ds';
import { UserInfoWrapper } from './EnterPage.styled';
import { getTableList } from '../../utils/getTableList';

interface FormValues {
  name: string;
  balance: number;
  joinExistingTable: boolean;
  tableId?: string;
}

const pageLimit = 9;

export const EnterPage: React.FC = () => {
  const playerContext = useContext(PlayerContext);
  const navigate = useNavigate();
  const [modalActive, setModalActive] = useState<string>("");
  const [tablePage, setTablePage] = useState<number>(1);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
    setError,
  } = useForm<FormValues>();

  const handleSetTablePage = () => {
    setTablePage(tablePage + 1);
  }

  useEffect(() => {
    const handleTableCreated = async (
      allTables: string,
      table: string,
      player: string,
      chat: string
    ) => {
      const parsedData = player == "" ? null : JSON.parse(player);
      if (parsedData != null && parsedData._name == playerContext?.playerName) {
        game.onTableCreated(
          table == "" ? [] : JSON.parse(table),
          player == "" ? [] : JSON.parse(player),
          chat == "" ? null : JSON.parse(chat)
        );

        if (game.table && game.player) {
          await addNewGameTable(game.table.id)
          navigate(`/table?id=${game.table.id}`);
        }

        game.modalUpdate(true);

        const soundSettings = game.music?.getLoacaleSettings();
        if (soundSettings) {
          const { musicVolume, soundsVolume } = soundSettings;
          game.music?.setMusicVolume(musicVolume);
          game.music?.setSoundVolume(soundsVolume);
        } else {
          game.music?.setMusicVolume(0.1);
        }

        game.music?.bg?.play();
      } else {
        let currentTableList: TableData[] | undefined;

        if (allTables == "") {
          // Table list updated by joining player
          currentTableList = playerContext?.tableList;
        } else {
          currentTableList = Object.values(JSON.parse(allTables));
        }

        if (currentTableList == undefined || table == '') return;

        const updatedTable = JSON.parse(table);
        const updatableTableIndex = currentTableList.findIndex(_table => _table.table_id == updatedTable.id)

        if (updatableTableIndex == undefined || updatableTableIndex == -1) return;

        currentTableList[updatableTableIndex].player_count = updatedTable["allPlayers"].length;
        currentTableList[updatableTableIndex].allPlayers = updatedTable["allPlayers"];
        playerContext?.tableListhandler(currentTableList);
      }
    };

    const handleError = () => {
      setError('tableId', { message: 'Invalid table ID' });
      const tableIdInput = document.querySelector<HTMLInputElement>(
        'input[name="tableId"]'
      );
      if (tableIdInput) {
        tableIdInput.value = '';
      }
    };

    const handleGetTables = async (allTables: string) => {
      let currentTableList: TableData[] = [];
      const res = await getTableList(playerContext?.playerId);
      const data = res?.tableData;
      if (data != undefined) {
        currentTableList = Object.values(data)
      }
      const allTablesList: any[] = Object.values(JSON.parse(allTables));
      const updatedArray = currentTableList.map(item => {
        // Find the matching object in the second array
        const matchingObject = allTablesList.find(
          obj => obj.id === item.table_id
        );

        // Add the `allPlayers` value if a match is found
        item.table_name = matchingObject ? matchingObject.tableName : item.table_name
        return {
          ...item,
          allPlayers: matchingObject ? matchingObject.allPlayers : [] // Default to an empty array if no match
        };
      });
      playerContext?.tableListhandler(updatedArray);
    }

    const handleTableDeleted = async (data: string) => {
      playerContext?.tableListhandler(JSON.parse(data))
    }

    socket.on(SocketOn.TableCreated, handleTableCreated);
    socket.on(SocketOn.TableDeleted, handleTableDeleted);
    socket.on(SocketOn.Error, handleError);
    socket.on(SocketOn.SendTables, handleGetTables);
    return () => {
      socket.off(SocketOn.TableCreated, handleTableCreated);
      socket.off(SocketOn.TableDeleted, handleTableDeleted);
      socket.off(SocketOn.Error, handleError);
      socket.off(SocketOn.SendTables, handleGetTables);
    };
    // handleTableCreated()
  }, [navigate, setError, playerContext, tablePage]);

  useEffect(() => {
    game.onGlobalChatCreate();
  }, [])

  useEffect(() => {
    game.emit[SocketEmit.GetTables]();
  }, [playerContext?.playerId])

  const handleSetModal = (active: string) => {
    setModalActive(active)
  }


  return (
    <HomeWrapper>
      <Header />
      {
        playerContext?.wallet.connected && (
          <UserInfoWrapper>
            <QuickPlay
              playerId={playerContext.playerId}
              playerName={playerContext?.playerName == undefined ? "" : playerContext?.playerName}
              playerAddress={playerContext?.wallet == undefined || playerContext?.wallet.publicKey == undefined ? "" : playerContext?.wallet.publicKey?.toString()}
              balance={playerContext?.tokenBalance == undefined ? 0 : playerContext?.tokenBalance}
              playerAvatar={playerContext?.avatar}
              playerRole={playerContext.role}
              blocked={playerContext.blocked ? playerContext.blocked : false}
            />
            <UserInfo setActive={handleSetModal} />
          </UserInfoWrapper>
        )
      }
      <GameTables setTablePage={handleSetTablePage} setActive={handleSetModal} tablePage={tablePage} pageLimit={pageLimit} />
      <Leaderboard fullView={false} />
      <AddBalanceForm modalActive={modalActive} setModalActive={handleSetModal} />
      <Footer />
    </HomeWrapper>
  );
};
